var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TablePagination, TableOptions } from '@/typings';
import { State, Getter, Mutation } from 'vuex-simple';
var ItemsModule = /** @class */ (function () {
    function ItemsModule() {
        this.items = [];
        this.selectedItem = {};
        this.tablePagination = {
            page: 1,
            itemsPerPage: 10,
            itemsPerPageOptions: [10, 20, 50, 100],
            disabled: false,
        };
        this.tableOptions = {
            multiSort: false,
            sortBy: '',
            sortDesc: false,
            fixedHeight: true,
        };
        this.filters = {
            includeDeleted: false,
        };
    }
    Object.defineProperty(ItemsModule.prototype, "filteredItemsByDeleted", {
        get: function () {
            var items = this.items;
            // if there is no unique id then add one
            // https://github.com/vuetifyjs/vuetify/issues/3897
            if (items && items.length > 0 && items[0].hasOwnProperty('id') === false) {
                items = items.map(function (item, index) { return (__assign({ id: index + 1 }, item)); });
            }
            return this.filters.includeDeleted
                ? items
                : // tslint:disable-next-line:no-string-literal
                    items.filter(function (item) { return item['isDeleted'] ? item['isDeleted'] === false : true; });
        },
        enumerable: false,
        configurable: true
    });
    ItemsModule.prototype.setItems = function (items) {
        this.items = items;
    };
    ItemsModule.prototype.setSelectedItem = function (item) {
        this.selectedItem = item;
    };
    ItemsModule.prototype.setIncludeDeletedFilter = function (includeDeleted) {
        this.filters.includeDeleted = includeDeleted;
    };
    ItemsModule.prototype.setPaginationPage = function (payload) {
        this.tablePagination.page = payload;
    };
    ItemsModule.prototype.setPaginationItemsPerPage = function (payload) {
        this.tablePagination.itemsPerPage = payload;
    };
    ItemsModule.prototype.setPaginationItemsPerPageOptions = function (payload) {
        this.tablePagination.itemsPerPageOptions = payload;
    };
    ItemsModule.prototype.setPaginationDisabled = function (payload) {
        this.tablePagination.disabled = payload;
    };
    ItemsModule.prototype.setTableOptionsSortBy = function (payload) {
        if (Array.isArray(payload)) {
            this.tableOptions.multiSort = true;
        }
        else {
            this.tableOptions.multiSort = false;
        }
        this.tableOptions.sortBy = payload;
    };
    ItemsModule.prototype.setTableOptionsSortDesc = function (payload) {
        if (Array.isArray(payload)) {
            this.tableOptions.multiSort = true;
        }
        else {
            this.tableOptions.multiSort = false;
        }
        this.tableOptions.sortDesc = payload;
    };
    ItemsModule.prototype.setTableOptionsSort = function (payload) {
        this.tableOptions.multiSort = Array.isArray(payload.sortBy);
        this.tableOptions.sortBy = payload.sortBy;
        this.tableOptions.sortDesc = payload.sortDesc;
    };
    ItemsModule.prototype.setTableFixedHeight = function (payload) {
        this.tableOptions.fixedHeight = payload;
    };
    var _a, _b, _c;
    __decorate([
        State(),
        __metadata("design:type", Array)
    ], ItemsModule.prototype, "items", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], ItemsModule.prototype, "selectedItem", void 0);
    __decorate([
        State(),
        __metadata("design:type", typeof (_a = typeof TablePagination !== "undefined" && TablePagination) === "function" ? _a : Object)
    ], ItemsModule.prototype, "tablePagination", void 0);
    __decorate([
        State(),
        __metadata("design:type", typeof (_b = typeof TableOptions !== "undefined" && TableOptions) === "function" ? _b : Object)
    ], ItemsModule.prototype, "tableOptions", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], ItemsModule.prototype, "filters", void 0);
    __decorate([
        Getter(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ItemsModule.prototype, "filteredItemsByDeleted", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setItems", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof T !== "undefined" && T) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setSelectedItem", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setIncludeDeletedFilter", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setPaginationPage", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setPaginationItemsPerPage", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setPaginationItemsPerPageOptions", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setPaginationDisabled", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setTableOptionsSortBy", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setTableOptionsSortDesc", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setTableOptionsSort", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ItemsModule.prototype, "setTableFixedHeight", null);
    return ItemsModule;
}());
export { ItemsModule };
